<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:95%;margin-left: 2.5%;margin-top:1.5%;height:95%;background-color: white;">
            <div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 1vh;padding-top: 10px;padding-left: 10px;"
				
				>	
                    <div style="height: 35px;width:120px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==0?'#3c9cff':'#d9ecff',color:type==0?'white':'#409eff'}" @click="type=0,setcontent(0)"
                    >
                        {{ "天选姬_Official" }}
                    </div>
                    <div style="height: 35px;width:120px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==1?'#3c9cff':'#d9ecff',color:type==1?'white':'#409eff'}" @click="type=1,setcontent(1)"
                    >
                        {{ "RO姬_Official" }}
                    </div>
                    <div style="height: 35px;width:120px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==2?'#3c9cff':'#d9ecff',color:type==2?'white':'#409eff'}" @click="type=2,setcontent(2)"
                    >
                        {{ "ElevenOfficial_" }}
                    </div>
                    
			</div>
			<div style="width: 100%;height: 80%;display: flex;flex-direction: row;align-items: center;">
                <div style="width: 45%;margin-right: 5%;border-radius: 5px;border:0.5px solid #efefef;height: 100%;">
                    
                    <div style="font-size: 20px;padding:5px;display: flex;flex-direction: row;align-items: center;">
                        <div>编辑</div>
                        <div style="width: 70px;height: 30px;color:white;background-color: #3c9cff;border-radius: 5px;display: flex;align-items: center;justify-content: center;font-size: 18px;margin-left: auto;"
                        @click="save()"
                        >保存</div>
                    </div>
                    <vue-editor ref="myEditor"  v-if="content!=null" v-model="content" :editor-toolbar="customToolbar" style="height: 100%;width:100%;"></vue-editor>
                </div>
                <div style="width: 45%;margin-left: 5%;border-radius: 5px;border:0.5px solid #efefef;height: 100%;overflow-y: auto;">
                     <div style="font-size: 20px;padding:5px;border-bottom: 0.5px solid #efefef;">预览</div>
                    <div style="width:96%;height:96%;padding:2%" v-html="content"></div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import {post} from "../axios/request.js"
import { VueEditor } from "vue2-editor";
export default {
  name:"info",
  components: { VueEditor },
  data() {
    return {
        customToolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image", "code-block"]
        ],
        content:null,
        type:0
    }
  },
  mounted() {
    post("/api/getinfo",{}).then((res)=>{
        this.list=res.data.data;
        this.content=''
        this.$nextTick(() => {
        if (this.$refs.myEditor) {
            this.$refs.myEditor.quill.clipboard.dangerouslyPasteHTML(0,this.list[0].info)
            this.$forceUpdate();
        }
      });
        

    })
  },
  methods: {
    setcontent(e){
        this.content=this.list[e].info;
        let that=this;
        this.content=null;
        that.content=''
            setTimeout(()=>{
                that.$nextTick(() => {
                that.content=''
                that.$refs.myEditor.quill.clipboard.dangerouslyPasteHTML(0,that.list[e].info)
                that.$forceUpdate();
                console.log(that.content)
                })
            },500)
           
    },
    save(){
        
        post("/api/admin/updateinfo",{id:this.type+1,info:this.content}).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '成功',
                    message: res.data.msg,
                    type: 'success'
                });
            }else{
                this.$notify({
                    title: '错误',
                    message: '未知的系统错误',
                    type: 'error'
                });
            }
        });
    }
  }
}
</script>
<style scoped>

</style>